module.exports = __webpack_public_path__ + "img/paypal.4726623b.png";